import { useMutation, useQueryClient, type UseMutationOptions } from "@tanstack/react-query";

import type { AcuityResolutionResponse } from "@/core/types";

import { acuityKeys } from "../keyFactory";
import {
  postAcuityResolution,
  type AcuityResolutionVariables,
} from "../queryFunctions/postAcuityResolution";

export function useAcuityResolution({
  onSuccess,
  ...options
}: UseMutationOptions<AcuityResolutionResponse, unknown, AcuityResolutionVariables> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: postAcuityResolution,
    onSuccess: async (data, variables, context) => {
      // invalidate the query which fetches patient's current acuity/updates
      await queryClient.invalidateQueries({
        queryKey: acuityKeys.current(variables.patientId),
      });

      onSuccess?.(data, variables, context);
    },
  });
}
